import React from 'react';
import {
  DndContext,
  useSensors,
  useSensor,
  PointerSensor as LibPointerSensor,
  rectIntersection,
} from '@dnd-kit/core';

const MAX_DND_DEPTH_ALLOWED = 3;

export class PointerSensor extends LibPointerSensor {
  static activators = [
    {
      eventName: 'onPointerDown',
      handler: ({ nativeEvent: event }, { onActivation }) => {
        if (!event.isPrimary || event.button !== 0) {
          return false;
        }
        // Exclude popovers from dragging
        if (event.target.classList.contains('popover__content')) return false;

        let current = event.target;
        let parentLevel = 0;

        while (parentLevel <= MAX_DND_DEPTH_ALLOWED) {
          if (current.dataset.dragElement) {
            onActivation?.({ event });
            return true;
          } else {
            current = current.parentElement;
            parentLevel++;
          }
        }

        return false;
      },
    },
  ];
}

const detectOverlayColilision = (args) => {
  const dragEl = document.querySelector('.dragging-label');
  if (!dragEl) return rectIntersection(args);

  const dragElPreviewRect = dragEl.getBoundingClientRect();
  return rectIntersection({ ...args, collisionRect: dragElPreviewRect });
};

const LabelsDnd = ({ children }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),
  );

  return (
    <DndContext sensors={sensors} collisionDetection={detectOverlayColilision}>
      {children}
    </DndContext>
  );
};

export default LabelsDnd;
